/**
 * Generate and download Excel template for product import
 */
export const downloadProductImportTemplate = async () => {
    try {
        const XLSX = await import('xlsx');
        const workbook = XLSX.utils.book_new();

        const headers = [
            'Item Code',
            'Name',
            'Sales Price Retail',
            'Discounted Price Retail',
            'Sales Price Wholesale',
            'Discounted Price Wholesale',
            'Available Quantity',
            'Unit',
            'Category',
            'VAT Rate (%)',
            'Price Includes VAT (TRUE/FALSE)'
        ];

        const sampleData = [
            ['PROD-001', 'Fresh Eggs', '28.00', '25.00', '21.50', '19.00', '100', 'dozen', 'Dairy & Eggs', '5', 'FALSE'],
            ['PROD-002', 'Milk', '8.50', '', '6.00', '', '200', 'liter', 'Dairy & Eggs', '5', 'FALSE'],
            ['PROD-003', 'Bread', '5.00', '4.50', '3.50', '3.00', '150', 'pcs', 'Bakery', '5', 'FALSE']
        ];

        const worksheet = XLSX.utils.aoa_to_sheet([headers, ...sampleData]);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Import Template');

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'product_import_template.xlsx';
        a.click();
        URL.revokeObjectURL(url);
    } catch (err) {
        console.error('Template download failed:', err);
        throw err;
    }
};

/**
 * Export products to Excel
 */
export const handleExportProductsExcel = async (products, companyName) => {
    try {
        const XLSX = await import('xlsx');
        const exportData = products.map(p => ({
            'Item Code': p.itemCode || '',
            'Name': p.name || '',
            'Sales Price Retail': p.retailPrice || '',
            'Discounted Price Retail': p.discountedRetailPrice || '',
            'Sales Price Wholesale': p.price || '',
            'Discounted Price Wholesale': p.discountedPrice || '',
            'Available Quantity': p.stock || '',
            'Unit': p.unit || '',
            'Category': p.category || '',
            'VAT Rate (%)': p.vatRate !== undefined ? p.vatRate : 5,
            'Price Includes VAT (TRUE/FALSE)': p.priceIncludesVat ? 'TRUE' : 'FALSE'
        }));

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Products');

        const dateStr = new Date().toISOString().split('T')[0];
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `products_export_${companyName}_${dateStr}.xlsx`;
        a.click();
        URL.revokeObjectURL(url);
    } catch (err) {
        console.error('Export failed:', err);
        throw err;
    }
};

/**
 * Validate Excel file before upload
 */
export const validateExcelFile = (file) => {
    const errors = [];

    // Check file exists
    if (!file) {
        errors.push('Please select a file');
        return { valid: false, errors };
    }

    // Check file type
    const fileName = file.name.toLowerCase();
    if (!fileName.endsWith('.xlsx') && !fileName.endsWith('.xls')) {
        errors.push('File must be in Excel format (.xlsx or .xls)');
    }

    // Check file size (max 10MB)
    const maxSize = 10 * 1024 * 1024; // 10MB
    if (file.size > maxSize) {
        errors.push('File size must be less than 10MB');
    }

    // Check if file is empty
    if (file.size === 0) {
        errors.push('File is empty');
    }

    return {
        valid: errors.length === 0,
        errors
    };
};
